import { systemApi } from '../api/system';
import { isRealtimeConnected, subscribeRealtime } from './realtime';

export const maintenanceResponseEvent = 'amposter:maintenance-response';

// One initial read, then socket snapshots/events. No recurring HTTP timer.
export function watchMaintenance(update, onUnavailable = () => {}) {
  let active = true, revision = 0, pending = false;
  const apply = state => {
    if (!active || typeof state?.enabled !== 'boolean') return;
    revision++;
    update(state);
  };
  const check = async () => {
    if (pending) return;
    if (navigator.onLine === false) { if (active) onUnavailable(); return; }
    pending = true;
    const started = revision;
    try {
      const state = await systemApi.maintenance();
      // A late initial HTTP response cannot overwrite a newer socket/error event.
      if (active && started === revision) apply(state);
    } catch { if (active && started === revision) onUnavailable(); }
    finally { pending = false; }
  };
  const stop = subscribeRealtime(event => {
    if (event.type === 'maintenance.changed') apply(event.data);
    else if (['ready', 'resync', 'pong'].includes(event.type) && event.data?.maintenance) apply(event.data.maintenance);
    else if (event.type === 'resync' && !isRealtimeConnected()) check();
  });
  const response = event => apply(event.detail);
  const resume = () => { if (!document.hidden && !isRealtimeConnected()) check(); };
  window.addEventListener(maintenanceResponseEvent, response);
  window.addEventListener('online', resume);
  document.addEventListener('visibilitychange', resume);
  check();
  return () => {
    active = false;
    stop();
    window.removeEventListener(maintenanceResponseEvent, response);
    window.removeEventListener('online', resume);
    document.removeEventListener('visibilitychange', resume);
  };
}
